import PropTypes from 'prop-types';

import { ReactComponent as ArrowRightSVG } from 'icons/arrow-right-small.svg';
import { ReactComponent as ArrowLeftSVG } from 'icons/arrow-left-small.svg';

const ToolbarMobile = ({ label, onNavigate }) => {
  const carryingHandleActionClick = (action) => () => onNavigate(action);

  return (
    <div className="th-calendar-toolbar">
      <div className="th-toolbar-views flex">
        <div className="th-btn-group">
          <button
            className="th-btn th-btn-whitegrey"
            onClick={carryingHandleActionClick('PREV')}
          >
            <ArrowLeftSVG />
          </button>
          <button
            className="th-btn th-btn-whitegrey"
            onClick={carryingHandleActionClick('NEXT')}
          >
            <ArrowRightSVG />
          </button>
        </div>
      </div>
      <span className="th-toolbar-label">{label}</span>
      <div className="th-toolbar-views th-btn-group">
        <button
          className="th-btn th-btn-whitegrey ml10"
          onClick={carryingHandleActionClick('TODAY')}
        >
          Today
        </button>
      </div>
    </div>
  );
};

ToolbarMobile.propTypes = {
  label: PropTypes.string,
  onNavigate: PropTypes.func,
};

export default ToolbarMobile;
